"use client";

import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { ResponsiveCommandSelect } from "@/components/ui/responsive-select";
import { Control } from "react-hook-form";
import type { CommunicationFormValues } from "./communicationFormSchema";

interface DirectionAndStatusProps {
  control: Control<CommunicationFormValues>;
  directionOptions: Array<{ value: string; label: string; description?: string }>;
  statusOptions: Array<{ value: string; label: string }>;
  isSubmitting: boolean;
}

export const DirectionAndStatusFields: React.FC<DirectionAndStatusProps> = ({
  control,
  directionOptions,
  statusOptions,
  isSubmitting,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={control}
        name="direction"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Direction</FormLabel>
            <FormControl>
              <ResponsiveCommandSelect
                value={field.value || ""}
                onValueChange={field.onChange}
                options={directionOptions}
                placeholder="Select direction"
                disabled={isSubmitting}
                title="Communication Direction"
                description="Whether this communication was received or sent"
              />
            </FormControl>
            <FormDescription>Whether this communication was received or sent</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status</FormLabel>
            <FormControl>
              <ResponsiveCommandSelect
                value={field.value || ""}
                onValueChange={field.onChange}
                options={statusOptions}
                placeholder="Select status"
                disabled={isSubmitting}
                title="Communication Status"
                description="Current status of this communication"
              />
            </FormControl>
            <FormDescription>Current status of this communication</FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
